import { useDispatch } from 'react-redux';
import FJImageInput from '../../../../common/components/FJImageInput/FJImageInput';
import useLocalStore from '../../../../hooks/useLocalStore';
import { useSelector } from 'react-redux';
import { setSliceIsDraggingFileAction } from '../../../../redux/slices/FJSliceCommon';
import FJActionImageExtender from '../../../../redux/action/FJActionImageExtender';
import { UPLOAD_FILE_TYPE_IMAGE_EXTENDER } from '../../../../config/dataConfig/FJGenerateData';
import FJConstant from '../../../../constants/FJConstant';
import FJActionEditPage from '../../../../redux/action/FJActionEditPage.js';

const FJImageExtenderImageUploadContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();

    const isDraggingFile = useSelector(state => state.common.isDraggingFile);
    const uploadImageInfo = useSelector(state => state.imageExtender.uploadImageInfo);
    const taskStatus = useSelector(state => state.common.taskStatus);

    const uploadImg = file => {
        if (taskStatus !== FJConstant.DEFAULT) {
            return;
        }
        dispatch(FJActionImageExtender.uploadImageAction(file));
    };

    const _setIsDraggingFile = value => {
        if (taskStatus !== FJConstant.DEFAULT) {
            return;
        }
        dispatch(setSliceIsDraggingFileAction(value));
    };

    const _openMediaLibrary = () => {
        dispatch(FJActionEditPage.openMediaLibraryAction());
    };

    return (
        <FJImageInput
            setIsDraggingFile={_setIsDraggingFile}
            uploadImg={uploadImg}
            openMediaLibrary={_openMediaLibrary}
            isDraggingFile={isDraggingFile}
            uploadImageInfo={uploadImageInfo}
            acceptFile={UPLOAD_FILE_TYPE_IMAGE_EXTENDER}
            taskStatus={taskStatus}
        />
    );
};

export default FJImageExtenderImageUploadContainer;
